// extracted by mini-css-extract-plugin
export default {"TableHeaderContainer":"l8t52G","tableHeaderContainer":"l8t52G","TableMobileHeaderContainer":"G2UgaF","tableMobileHeaderContainer":"G2UgaF"};